import { render, staticRenderFns } from "./WxQrcodeOverlay.vue?vue&type=template&id=940a8750&scoped=true&"
import script from "./WxQrcodeOverlay.vue?vue&type=script&lang=js&"
export * from "./WxQrcodeOverlay.vue?vue&type=script&lang=js&"
import style0 from "./WxQrcodeOverlay.vue?vue&type=style&index=0&id=940a8750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940a8750",
  null
  
)

export default component.exports